
import { useEffect,useState } from "react";
import { useNavigate } from "react-router-dom";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const useMarketPlaceUserVerification = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
     const token = localStorage.getItem("access_token");
    if (!token) {
      navigate("/login");
      return;
    }
    const fetchApprovalStatus = async () => {
      try {
        setLoading(true)
        const res = await fetch(`${BASE_URL}/marketplace/verification-status`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });
        const data = await res.json();
        console.log("The new data is:",data)
        if (data?.is_verified === true && data?.verification_type==="researcher") {
          navigate("/marketplace/independent_researcher");
        }
        else if(data?.is_verified === true && data?.verification_type==="university")
        {
           navigate("/marketplace/university");
        }
        else if(data?.is_verified === true && data?.verification_type==="industry")
        {
           navigate("/marketplace/industry");
        }
        else if(data?.is_verified === true && data?.verification_type==="dean")
        {
           navigate(`/marketplace/${data?.universityName}/dean`,{state:{id:data?.university_id}});
        }
        else if(data?.is_verified === true && data?.verification_type === "labhead")
        {
          navigate(`/marketplace/${data?.universityName}/${data?.dean_name}/${data?.department_name}/${data?.lab_name}/labhead`,{state:{id:data?.university_id,dean_id:data?.dean_id,department_id:data?.department_id,lab_id:data?.profile_id,profile_id:data?.profile_id,user_id:data?.user_id}});
        }
        else if(data?.is_verified === true && data?.verification_type === "manager")
        {
          navigate("/marketplace/industry/manager");
        }
        else if(data?.is_verified === true && data?.verification_type === "assistant_manager")
        {
          navigate('/marketplace/industry/manager/assistant_manager')
        }
        else{
            navigate("/marketplace");
        }
      } catch (err) {
        console.error(err);
        navigate("/marketplace");
      }finally{
        setLoading(false)
      }
    };

    fetchApprovalStatus();
  }, [navigate]);

  return {loading}
};

export default useMarketPlaceUserVerification;
